/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { FormattedMessage } from "react-intl";
import browser from "../../images/browser.png";
import compose from "../../images/compose.png";
import globe from "../../images/globe.png";
import headerLogo from "../../images/headerLogo.png";
import right from "../../images/right.png";
//import { DollarOutlined,UsergroupAddOutlined,PlusSquareOutlined,CarOutlined,HomeOutlined,ShoppingOutlined } from '@ant-design/icons';
export const Nav20DataSource = {
  isScrollLink: true,
  wrapper: { className: "header2 home-page-wrapper" },
  page: { className: "home-page kluji4nhlik-editor_css" },
  logo: {
    className: "header2-logo klujhw525fj-editor_css",
    children: headerLogo,
  },
  LinkMenu: {
    className: "header2-menu",
    children: [
      {
        name: "linkNav",
        href: "/",
        key: "linkNav",
        children: <FormattedMessage id="home" />,
        className: "menu-item klujhwre4e7-editor_css",
      },
      // {
      //   name: 'linkNav~klujl5q4s9',
      //   href: '/Referral',
      //   children: (<FormattedMessage id="referral"/>),
      //   className: 'menu-item klujqx09cf-editor_css',
      // },
      {
        name: "linkNav~klujm8vn5yj",
        href: "/APIs",
        key: "linkNav~klujm8vn5yj",
        children: <FormattedMessage id="api" />,
        className: "menu-item klujr10tzlr-editor_css",
      },
      {
        name: "linkNav~klujml6z4sr",
        href: "/Faq",
        key: "linkNav~klujml6z4sr",
        children: <FormattedMessage id="faqs" />,
        className: "menu-item klujrglxnl8-editor_css",
      },
    ],
  },
  mobileMenu: { className: "header2-mobile-menu" },
};

// export const Banner20DataSource = {
//   wrapper: { className: 'banner2' },
//   BannerAnim: {
//     children: [
//       {
//         name: 'elem0',
//         BannerElement: { className: 'banner-user-elem' },
//         page: { className: 'home-page banner2-page kn9wmnm2duo-editor_css' },
//         textWrapper: {
//           className: 'banner2-text-wrapper kn9wo5uhif7-editor_css',
//         },
//         bg: { className: 'bg bg0 kn9wmowvkal-editor_css' },
//         title: {
//           className: 'banner2-title kn9wna3lrq-editor_css',
//           children: <FormattedMessage id="ETIQAAFFILIATES"/>,
//         },
//         content: {
//           className: 'banner2-content',
//           children: [<FormattedMessage id="banner-subtitle"/> ," ", <FormattedMessage id="banner-subtitle2"/>],
//         },
//       },
//     ],
//   },
// };

export const Banner00DataSource = {
  wrapper: { className: "banner0 kluj5bedfy-editor_css" },
  textWrapper: { className: "banner0-text-wrapper kluj0w510r-editor_css" },
  title: {
    className: "banner0-title kluj11l9ytm-editor_css",
    children: (
      <span>
        <p>
          <FormattedMessage id="ETIQAAFFILIATES" />
        </p>
      </span>
    ),
  },
  content: {
    className: "banner0-content kluj0yxpcdt-editor_css",
    children: (
      <span>
        <span>
          <p>
            <FormattedMessage id="banner-subtitle" />
          </p>
          <p>
            <FormattedMessage id="banner-subtitle2" />
          </p>
        </span>
      </span>
    ),
  },
  button: {
    className: "banner0-button kluj0wlyjm8-editor_css",
    children: "Learn More",
  },
};

export const Feature71DataSource = {
  wrapper: { className: "home-page-wrapper feature7-wrapper" },
  page: { className: "home-page feature7" },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: "feature7-title-wrapper",
    children: [
      {
        name: "title",
        className: "feature7-title-h1",
        children: "APIs",
      },
      {
        name: "content",
        className: "feature7-title-content",
        children:
          "Welcome to Etiqa API Portal. Etiqa API portal provides API service to make it simple to sell and offer our products via your website or mobile app.",
      },
    ],
  },
};

// export const Content50DataSource = {
//   wrapper: { className: 'home-page-wrapper content5-wrapper' },
//   page: { className: 'home-page content5' },
//   OverPack: { playScale: 0.3, className: '' },
//   titleWrapper: {
//     className: 'title-wrapper',
//     children: [
//       { name: 'title', children:(<FormattedMessage id="content5-title"/>), className: 'title-h1' },
//       {
//         name: 'content',
//         className: 'title-content',
//         children:(<FormattedMessage id="content5-sub-title"/>),
//       },
//     ],
//   },
//   block: {
//     className: 'content5-img-wrapper',
//     gutter: 16,
//     children: [
//       {
//         name: 'block0',
//         className: 'block',
//         md: 8,
//         xs: 24,
//         children: {
//           wrapper: { className: 'content5-block-content' },
//           img: {
//             children:
//             'https://cdn0.iconfinder.com/data/icons/free-daily-icon-set/512/Dollar-512.png',
//             className:"img-block"
//           },
//           content: { children: 'eEASY save V API' },
//         },
//       },
//       {
//         name: 'block1',
//         className: 'block',
//         md: 8,
//         xs: 24,
//         children: {
//           wrapper: { className: 'content5-block-content' },
//           img: {
//             children:
//               'https://cdn2.iconfinder.com/data/icons/people-80/96/Picture21-512.png',
//               className:"img-block"
//           },
//           content: { children: 'ePROTECT maid API' },
//         },
//       },
//       {
//         name: 'block2',
//         className: 'block',
//         md: 8,
//         xs: 24,
//         children: {
//           wrapper: { className: 'content5-block-content' },
//           img: {
//             children:
//               'https://cdn0.iconfinder.com/data/icons/security-double-colour-blue-black-vol-3/52/protection__shield__safety__protect-512.png',
//             className:"img-block"
//           },
//           content: { children: 'ePROTECT safety API' },
//         },
//       },
//       {
//         name: 'block3',
//         className: 'block',
//         md: 8,
//         xs: 24,
//         children: {
//           wrapper: { className: 'content5-block-content' },
//           img: {
//             children:
//               'https://cdn1.iconfinder.com/data/icons/ios-11-glyphs/30/car-512.png',
//             className:"img-block"
//           },
//           content: { children: 'Private Car Insurance API' },
//         },
//       },
//       {
//         name: 'block4',
//         className: 'block',
//         md: 8,
//         xs: 24,
//         children: {
//           wrapper: { className: 'content5-block-content' },
//           img: {
//             children:
//               'https://image.flaticon.com/icons/png/512/69/69524.png',
//             className:"img-block"
//           },
//           content: { children: 'Tiq Home Insurance API' },
//         },
//       },
//       {
//         name: 'block5',
//         className: 'block',
//         md: 8,
//         xs: 24,
//         children: {
//           wrapper: { className: 'content5-block-content' },
//           img: {
//             children:
//               'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ0rTSI_8rFfiuBzVsR0EH_gJJ0-Hg_EhQRNA&usqp=CAU',
//             className:"img-block"
//           },
//           content: { children: 'Tiq Travel Insurance API' },
//         },
//       },
//     ],
//   },
// };

export const Feature80DataSource = {
  wrapper: { className: "home-page-wrapper feature8-wrapper" },
  page: { className: "home-page feature8" },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: "feature8-title-wrapper",
    children: [
      {
        name: "title",
        className: "feature8-title-h1",
        children: (
          <span>
            <p>
              <FormattedMessage id="feature8-title" />
            </p>
          </span>
        ),
      },
      {
        name: "content",
        className: "feature8-title-content",
        children:
          "Get your developers onboard, very quickly. Learn how to incorporate our APIs in just few easy steps.",
      },
    ],
  },
  childWrapper: {
    className: "feature8-button-wrapper",
    children: [
      {
        name: "button",
        className: "feature8-button",
        children: {
          href: "#",
          children: "立即体验",
          className: "klvl2a9psor-editor_css",
        },
      },
    ],
  },
  Carousel: {
    dots: false,
    className: "feature8-carousel",
    wrapper: { className: "feature8-block-wrapper" },
    children: {
      className: "feature8-block",
      titleWrapper: {
        className: "feature8-carousel-title-wrapper",
        title: { className: "feature8-carousel-title" },
      },
      children: [
        {
          name: "block0",
          className: "feature8-block-row klvku9ubs6e-editor_css",
          gutter: 120,
          title: {
            className: "feature8-carousel-title-block",
            children: "平台自主训练流程",
          },
          children: [
            {
              className: "feature8-block-col",
              md: 8,
              xs: 24,
              name: "child0",
              arrow: {
                className: "feature8-block-arrow klvl0p650co-editor_css",
                children: right,
              },
              children: {
                className: "feature8-block-child klvkucbl7sn-editor_css",
                children: [
                  {
                    name: "image",
                    className: "feature8-block-image",
                    children: <img src={compose} />,
                  },
                  {
                    name: "title",
                    className: "feature8-block-title",
                    children: (
                      <span>
                        <p>
                          <FormattedMessage id="feature8-item-title1" />
                        </p>
                      </span>
                    ),
                  },
                  {
                    name: "content",
                    className: "feature8-block-content klvkv5hbh-editor_css",
                    children: (
                      <span>
                        <p>
                          <FormattedMessage id="feature8-item-sub-title1" />
                        </p>
                      </span>
                    ),
                  },
                ],
              },
            },
            {
              className: "feature8-block-col",
              md: 8,
              xs: 24,
              name: "child1",
              arrow: {
                className: "feature8-block-arrow",
                children: right,
              },
              children: {
                className: "feature8-block-child",
                children: [
                  {
                    name: "image",
                    className: "feature8-block-image",
                    children: <img src={browser} />,
                  },
                  {
                    name: "title",
                    className: "feature8-block-title",
                    children: (
                      <span>
                        <p>
                          <FormattedMessage id="feature8-item-title2" />
                        </p>
                      </span>
                    ),
                  },
                  {
                    name: "content",
                    className: "feature8-block-content klvkz4takkp-editor_css",
                    children: (
                      <span>
                        <span>
                          <p>
                            <FormattedMessage id="feature8-item-sub-title2" />
                          </p>
                        </span>
                      </span>
                    ),
                  },
                ],
              },
            },
            {
              className: "feature8-block-col klvkw556mw9-editor_css",
              md: 8,
              xs: 24,
              name: "child2",
              arrow: {
                className: "feature8-block-arrow",
                children: "",
              },
              children: {
                className: "feature8-block-child",
                children: [
                  {
                    name: "image",
                    className: "feature8-block-image",
                    children: <img src={globe} />,
                  },
                  {
                    name: "title",
                    className: "feature8-block-title",
                    children: (
                      <span>
                        <p>
                          <FormattedMessage id="feature8-item-title3" />
                        </p>
                      </span>
                    ),
                  },
                  {
                    name: "content",
                    className: "feature8-block-content klvkzg6ft3-editor_css",
                    children: (
                      <span>
                        <p>
                          <FormattedMessage id="feature8-item-sub-title3" />
                        </p>
                      </span>
                    ),
                  },
                ],
              },
            },
          ],
        },
      ],
    },
  },
};

function checkPath(){
  var basePathStage = "https://staging.etiqa.com.sg/api/";
  var basePathReal = "https://www.tiq.com.sg/api/";
    if(window.location.origin.includes("staging")){
      return basePathStage + "APIs";
    }else if(window.location.origin.includes("tiq")){
      return basePathReal + "APIs";
    }else{
      return window.location.origin + "/APIs";
    }
  }
  
export const Banner50DataSource = {
  wrapper: { className: "home-page-wrapper banner5" },
  page: { className: "home-page banner5-page" },
  childWrapper: {
    className: "banner5-title-wrapper",
    children: [
      {
        name: "title",
        children: "Sandbox Preview",
        className: "banner5-title",
      },
      {
        name: "explain",
        className: "banner5-explain",
        children: "Process & Function",
      },
      {
        name: "content",
        className: "banner5-content",
        children: (
          <span>
            <span>
              <p>Testing the API in online without development anything.</p>
              <hr />
              <p>
                1) Just only Write the request and Put an access token to
                sandbox.
              </p>
              <p>
                2) Api response or data message will be showing at the response
                body.
              </p>
            </span>
          </span>
        ),
      },
      {
        name: "button",
        className: "banner5-button-wrapper",
        children: {
          href: checkPath(),
          className: "banner5-button",
          type: "primary",
          children: "API Catalog",
        },
      },
    ],
  },
  image: {
    className: "banner5-image klvpaabrskn-editor_css",
  },
};
// export const Banner50DataSource = {
//   wrapper: { className: 'home-page-wrapper banner5' },
//   page: { className: 'home-page banner5-page' },
//   childWrapper: {
//     className: 'banner5-title-wrapper',
//     children: [
//       { name: 'title', children: (<FormattedMessage id="banner5-title"/>), className: 'banner5-title' },
//       {
//         name: 'explain',
//         className: 'banner5-explain',
//         children: (<FormattedMessage id="banner5-sub-title"/>),
//       },
//       {
//         name: 'content',
//         className: 'banner5-content',
//         children: (
//           <span>
//             <span>
//               <p><FormattedMessage id="banner5-item1"/></p>
//               <p><FormattedMessage id="banner5-item2"/></p>
//               <p><FormattedMessage id="banner5-item3"/></p>
//               <p><FormattedMessage id="banner5-item4"/></p>
//             </span>
//           </span>
//         ),
//       },
//       {
//         name: 'button',
//         className: 'banner5-button-wrapper',
//         children: {
//           href: '/Faq',
//           className: 'banner5-button',
//           type: 'primary',
//           children: (<FormattedMessage id="banner5-button"/>),
//         },
//       },
//     ],
//   },
//   image: {
//     className: 'banner5-image klvpaabrskn-editor_css',
//     children:
//       'https://st.depositphotos.com/2038453/2080/i/600/depositphotos_20803487-stock-photo-faq-3d-text-with-computer.jpg',
//   },
// };

// export const Content110DataSource = {
//   OverPack: {
//     className: 'home-page-wrapper content11-wrapper kn9z87ulgjh-editor_css',
//     playScale: 0.3,
//   },
//   titleWrapper: {
//     className: 'title-wrapper',
//     children: [
//       { name: 'title', children: 'Start building', className: 'title-h1' },
//       {
//         name: 'content',
//         children:
//           'Create a free account and try out the Sandbox to get started in a few simple steps',
//         className: 'title-content',
//       },
//     ],
//   },
//   button: {
//     className: '',
//     children: { a: { className: 'button', href: '#', children: 'Sign Up Now' } },
//   },
// };
